import { useState } from "react";
import { toast } from "sonner";
import { KeyRound } from "lucide-react";
import { Card } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { changePassword } from "@/lib/api";

export default function AdminSettings() {
    const [form, setForm] = useState({ current_password: "", new_password: "", confirm: "" });
    const [saving, setSaving] = useState(false);

    const onSubmit = async (e) => {
        e.preventDefault();
        if (form.new_password !== form.confirm) return toast.error("New passwords don\u2019t match");
        if (form.new_password.length < 6) return toast.error("New password must be at least 6 characters");
        setSaving(true);
        try {
            await changePassword(form.current_password, form.new_password);
            toast.success("Password updated");
            setForm({ current_password: "", new_password: "", confirm: "" });
        } catch (err) {
            toast.error(err?.response?.data?.detail || "Failed to change password");
        } finally { setSaving(false); }
    };

    return (
        <div className="space-y-6 max-w-xl">
            <div>
                <p className="font-mono text-[10px] uppercase tracking-[0.22em] text-paper/50">Settings</p>
                <h1 className="mt-1 font-display text-3xl sm:text-4xl">Security</h1>
                <p className="text-paper/70 mt-2">Change your admin password. The default is <span className="font-mono">admin / admin123</span>. Please change it.</p>
            </div>
            <Card className="p-6 rounded-2xl bg-white/[0.04] border-white/10">
                <form onSubmit={onSubmit} className="space-y-4">
                    <div className="space-y-1.5">
                        <Label className="text-paper/80" htmlFor="cp">Current password</Label>
                        <Input id="cp" type="password" value={form.current_password} onChange={(e) => setForm({ ...form, current_password: e.target.value })} required className="bg-white/[0.05] border-white/10 text-paper" data-testid="admin-current-password-input" />
                    </div>
                    <div className="space-y-1.5">
                        <Label className="text-paper/80" htmlFor="np">New password</Label>
                        <Input id="np" type="password" value={form.new_password} onChange={(e) => setForm({ ...form, new_password: e.target.value })} required className="bg-white/[0.05] border-white/10 text-paper" data-testid="admin-new-password-input" />
                    </div>
                    <div className="space-y-1.5">
                        <Label className="text-paper/80" htmlFor="cf">Confirm new password</Label>
                        <Input id="cf" type="password" value={form.confirm} onChange={(e) => setForm({ ...form, confirm: e.target.value })} required className="bg-white/[0.05] border-white/10 text-paper" data-testid="admin-confirm-password-input" />
                    </div>
                    <Button type="submit" disabled={saving} className="bg-paper text-ink hover:bg-paper/90" data-testid="admin-change-password-button">
                        <KeyRound className="h-4 w-4 mr-2" /> {saving ? "Updating…" : "Update password"}
                    </Button>
                </form>
            </Card>
        </div>
    );
}
